import { render, staticRenderFns } from "./PageEditorSectionMoveDownBtn.vue?vue&type=template&id=264ef031&scoped=true"
import script from "./PageEditorSectionMoveDownBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionMoveDownBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ef031",
  null
  
)

export default component.exports